module.exports = __webpack_public_path__ + "static/terrace-6b388b1bb8aaa27ef6ae24ebbf04788f.jpg";